export enum TranscriptKeys {
    DurationInPane = "DurationInPane",
    TranscriptInsertedFull = "TranscriptInsertedFull",
    TranscriptInsertedSection = "TranscriptInsertedSection",
    TranscriptTimestampClicks = "TranscriptTimestampClicks",
    TranscriptEditStarted = "TranscriptEditStarted",
    TranscriptEditSaved = "TranscriptEditSaved",
    TranscriptEditClosed = "TranscriptEditClosed",
    TranscriptEditSaveDurationSlowest = "TranscriptEditSaveDurationSlowest",
    PauseAudio = 'PauseAudio',
    PlayAudio = 'PlayAudio',
    PlaybackSpeedChange = 'PlaybackSpeedChange',
    SeekBackward = 'SeekBackward',
    SeekForward = 'SeekForward',
    ShowVolume = 'ShowVolume',
    VolumeChange = 'VolumeChange',
    UnknownAudioFeature = 'UnknownAudioFeature',
    PlayDurationAcrossSessionSecs = 'PlayDurationAcrossSessionSecs',
    AudioLengthSeconds = 'AudioLengthSeconds'
};